import { render } from "./Driver.vue?vue&type=template&id=0b72d47e&scoped=true"
const script = {}

import "./Driver.vue?vue&type=style&index=0&id=0b72d47e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b72d47e"]])

export default __exports__